/* [PATCH pozabljeno-geslo-fe v1] Pozabljeno geslo - javni strani:
   /pozabljeno-geslo          -> vpis e-naslova, POST /auth/pozabljeno-geslo (vedno isti odgovor)
   /ponastavi-geslo/:zeton    -> GET /auth/ponastavi-geslo/{zeton}, POST /auth/ponastavi-geslo
   Slog po PovabiloPage. */
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { api } from '../lib/api';

const vnosCls = 'w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white';
const gumbCls = 'w-full py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold disabled:opacity-50';

function Okvir({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <div className="w-full max-w-md bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8">
        <div className="text-center mb-6">
          <span className="text-2xl font-bold text-gray-900 dark:text-white">
            Alfa<span className="text-blue-600">Berg</span>
          </span>
        </div>
        {children}
        <p className="mt-6 text-center text-sm">
          <Link to="/prijava" className="text-blue-600 hover:underline">Nazaj na prijavo</Link>
        </p>
      </div>
    </div>
  );
}

export function PozabljenoGesloPage() {
  const [iskanje] = useSearchParams();
  const [email, setEmail] = useState(iskanje.get('email') || '');
  const [posiljam, setPosiljam] = useState(false);
  const [poslano, setPoslano] = useState('');

  const oddaj = async (e: React.FormEvent) => {
    e.preventDefault();
    setPosiljam(true);
    try {
      const r: any = await api.post('/auth/pozabljeno-geslo', { email });
      setPoslano(r?.data?.sporocilo || 'Če račun s tem e-naslovom obstaja, smo vam poslali e-pošto z navodili.');
    } catch (err: any) {
      toast.error(err?.response?.data?.detail || 'Zahteve ni bilo mogoče poslati');
    } finally {
      setPosiljam(false);
    }
  };

  return (
    <Okvir>
      {poslano ? (
        <div className="text-center">
          <p className="text-gray-700 dark:text-gray-200">{poslano}</p>
          <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
            Povezava velja 1 uro. Če e-pošte ne najdete, preverite tudi mapo z neželeno pošto.
          </p>
        </div>
      ) : (
        <>
          <p className="text-center text-gray-600 dark:text-gray-300 mb-6">
            Vpišite e-naslov, s katerim se prijavljate. Poslali vam bomo povezavo za nastavitev novega gesla.
          </p>
          <form onSubmit={oddaj} className="space-y-4">
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="vas@email.si" required autoFocus className={vnosCls} />
            <button type="submit" disabled={posiljam} className={gumbCls}>
              {posiljam ? 'Pošiljam ...' : 'Pošlji povezavo'}
            </button>
          </form>
        </>
      )}
    </Okvir>
  );
}

export function PonastaviGesloPage() {
  const { zeton } = useParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [napaka, setNapaka] = useState('');
  const [geslo, setGeslo] = useState('');
  const [geslo2, setGeslo2] = useState('');
  const [posiljam, setPosiljam] = useState(false);

  useEffect(() => {
    api.get(`/auth/ponastavi-geslo/${zeton}`)
      .then((r: any) => setEmail(r.data.email))
      .catch((err: any) => setNapaka(err?.response?.data?.detail || 'Povezava ni veljavna.'));
  }, [zeton]);

  const oddaj = async (e: React.FormEvent) => {
    e.preventDefault();
    if (geslo.length < 8) { toast.error('Geslo mora imeti vsaj 8 znakov'); return; }
    if (geslo !== geslo2) { toast.error('Gesli se ne ujemata'); return; }
    setPosiljam(true);
    try {
      await api.post('/auth/ponastavi-geslo', { zeton, geslo });
      toast.success('Geslo je spremenjeno. Prijavite se z novim geslom.');
      navigate('/prijava');
    } catch (err: any) {
      toast.error(err?.response?.data?.detail || 'Gesla ni bilo mogoče spremeniti');
    } finally {
      setPosiljam(false);
    }
  };

  return (
    <Okvir>
      {napaka && (
        <div className="text-center">
          <p className="text-red-600 dark:text-red-400">{napaka}</p>
          <p className="mt-4 text-sm">
            <Link to="/pozabljeno-geslo" className="text-blue-600 hover:underline font-semibold">Pošlji novo povezavo</Link>
          </p>
        </div>
      )}
      {!napaka && !email && (
        <p className="text-center text-gray-500 dark:text-gray-400">Preverjam povezavo ...</p>
      )}
      {!napaka && email && (
        <>
          <p className="text-center text-gray-600 dark:text-gray-300 mb-6">
            Nastavite novo geslo za račun<br />
            <span className="text-sm text-gray-400">{email}</span>
          </p>
          <form onSubmit={oddaj} className="space-y-4">
            <input type="password" value={geslo} onChange={(e) => setGeslo(e.target.value)}
              placeholder="Novo geslo (vsaj 8 znakov)" required autoFocus className={vnosCls} />
            <input type="password" value={geslo2} onChange={(e) => setGeslo2(e.target.value)}
              placeholder="Ponovi geslo" required className={vnosCls} />
            <button type="submit" disabled={posiljam} className={gumbCls}>
              {posiljam ? 'Shranjujem ...' : 'Shrani novo geslo'}
            </button>
          </form>
        </>
      )}
    </Okvir>
  );
}
